module.exports = __webpack_public_path__ + "img/hernan-zapatini.734eb71b.jpg";